import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput", "preview", "previewContainer"];

  connect() {
    this.fileInputTarget.addEventListener(
      "change",
      this.previewFile.bind(this)
    );
    this.previewContainerTarget.addEventListener(
      "click",
      this.triggerFileInput.bind(this)
    );
  }

  triggerFileInput() {
    this.fileInputTarget.click();
  }

  previewFile() {
    console.log("som v previewFile");
    const file = this.fileInputTarget.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewTarget.src = e.target.result;
        this.previewTarget.classList.remove("hidden");
      };
      reader.readAsDataURL(file);
    }
  }
}
